// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qs-1";
export var stateContainer = "_qs-0";